import { GuideConfigItem } from '@/views/components/GuideRemind/js/type.d'
import { config } from './config'
import router from '@/router'
import { GuideRemindFun } from '@/views/components/GuideRemind/js/type'
import { ComponentInternalInstance, inject, ref } from 'vue'

// 新手指引是否完成
export const isNewbieGuideFinished = ref(false)
export function setIsNewbieGuideFinished(finished = false) {
  isNewbieGuideFinished.value = finished
}

let guideRemindFun: GuideRemindFun

export const handleInject = () => {
  if (!guideRemindFun) {
    guideRemindFun = inject('guideRemindFun') as GuideRemindFun
  }
}

export const globalGuide = (showVisible: boolean, instance: ComponentInternalInstance | null) => {
  handleInject()
  if (showVisible) {
    handleGuide(instance)
    guideRemindFun(configItem)
  }
}

const configItem: GuideConfigItem = reactive({
  lists: [],
  isLastPage: false
})

export const handleGuide = (instance: ComponentInternalInstance | null) => {
  const name = router.currentRoute.value.name as keyof typeof config
  const configData = config[name](instance)
  Object.assign(configItem, configData)
}

export const forceVisible = (instance: ComponentInternalInstance | null) => {
  handleGuide(instance)
}

export function getRemindHtml(
  title: string,
  content: string,
  { maxWidth = 665 }: Record<string, number> = {}
) {
  return `<div style="max-width: ${maxWidth}px; font-size: 14px; line-height: 20px; word-break: break-all; white-space: normal;">
  <div style="margin-bottom: 8px;">
    ${title}
  </div>
  <div>
    ${content}
  </div>
  </div>`
}
